export const NYL_IDLE_TIMEOUT_SETTING_KEY = 'nylIdleTimeoutMinutes' as const;

export const DEFAULT_NYL_IDLE_TIMEOUT_MINUTES = 60;
export const MIN_NYL_IDLE_TIMEOUT_MINUTES = 1;
export const NYL_IDLE_WARNING_MINUTES = 5;

export type NylIdleTimeoutPolicy = {
  isEnabled: boolean;
  timeoutMinutes: number;
};

export function isValidNylIdleTimeoutMinutes(value: unknown): value is number {
  return (
    typeof value === 'number' && Number.isInteger(value) && value >= MIN_NYL_IDLE_TIMEOUT_MINUTES
  );
}

export function resolveNylIdleTimeoutPolicy(
  values: { nylIdleTimeoutMinutes?: unknown } | null | undefined,
): NylIdleTimeoutPolicy {
  const configuredValue = values?.nylIdleTimeoutMinutes;

  return {
    isEnabled: configuredValue !== undefined,
    timeoutMinutes: isValidNylIdleTimeoutMinutes(configuredValue)
      ? configuredValue
      : DEFAULT_NYL_IDLE_TIMEOUT_MINUTES,
  };
}

export function resolveNylIdleTimeoutMinutes(
  values: { nylIdleTimeoutMinutes?: unknown } | null | undefined,
): number {
  return resolveNylIdleTimeoutPolicy(values).timeoutMinutes;
}
